export class TenantPlan {
  public name: string;
  public startDate: Date;
  public endDate: Date;
  public maxActiveTeams: number;
  public canUseDisplayLogic: boolean;
  public canUploadDocuments: boolean;
  public canSendTeamEmail: boolean;
  public maxActivePersons: number;
  public canSaveViews: boolean;
  public canManageColumns: boolean;
  public maxWorkspaceLimit: number;
  public canScheduleEmailReminders: boolean;
  public canUseAdvancedAttributes: boolean;

  constructor(obj: any) {
    this.name = obj.name;
    this.startDate = obj.startDate;
    this.endDate = obj.endDate;
    this.maxActiveTeams = obj.maxActiveTeams;
    this.canUseDisplayLogic = obj.canUseDisplayLogic;
    this.canUploadDocuments = obj.canUploadDocuments;
    this.canSendTeamEmail = obj.canSendTeamEmail;
    this.maxActivePersons = obj.maxActivePersons;
    this.canSaveViews = obj.canSaveViews;
    this.canManageColumns = obj.canManageColumns;
    this.canScheduleEmailReminders = obj.canScheduleEmailReminders;
    this.canUseAdvancedAttributes = obj.canUseAdvancedAttributes;
    this.maxWorkspaceLimit = obj.maxWorkspaceLimit;
  }
}
